module.exports = __webpack_public_path__ + "static/media/Service Assurance Programme.e8df38ea.webp";